import type { QueryClient } from "@tanstack/react-query";

/** Prefix of every "My Music" list query (`["library", kind, limit]`). */
export const LIBRARY_KEY = ["library"] as const;

/** After a like, save or follow: the library lists that might show it refetch. */
export function invalidateLibrary(client: QueryClient) {
  return client.invalidateQueries({ queryKey: LIBRARY_KEY });
}
